import React from 'react';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';

import Modal from '~components/atoms/Modal';
import RolesCreateRoleForm from '../RolesCreateRoleForm';

import { TCreateNewRoleReduxParams } from '~types/feat/admin';

const RolesCreateNewRoleModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.admin.modals.createNewRoleModalIsOpen);
    const isLoading = useAppSelector(state => state.admin.loadings.createNewRole);
    const error = useAppSelector(state => state.admin.errors.createNewRole);

    const handleModalOnClose = () => {
        dispatch(combinedActions.adminResetCreateNewRoleState());
        dispatch(combinedActions.adminSetCreateNewRoleModalIsOpen(false));
    };

    const handleOnSubmit = (data: TCreateNewRoleReduxParams) => !isLoading && dispatch(combinedActions.adminCreateNewRoleAttempt(data));
    const setError = (errorString: string) => dispatch(combinedActions.adminSetCreateNewRoleError(errorString));

    return (
        <Modal
            title='Create Role'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            <RolesCreateRoleForm
                submitButtonLabel='Create Role'
                onSubmit={handleOnSubmit}
                actionButtonIsLoading={isLoading}
                error={error}
                setError={setError}
            />
        </Modal>
    );
};

export default RolesCreateNewRoleModal;
